module.exports = "/assets/data/6ff4d6fb4986d643d381e9786a75f09b-NN7.data.json";